import { isDockingEnabledForProfile } from "lib/consts/docking";
import { useRobotProfileLiveness } from "providers/RobotProfileLivenessProvider";

/** True when the dock/undock control should appear (running profile supports docking). */
export function useDockingUiVisible(): boolean {
    const { profileRunning, activeProfile } = useRobotProfileLiveness();
    return profileRunning && isDockingEnabledForProfile(activeProfile);
}

